/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PcrReportingTask } from '../models/pcr-reporting-task';
import { PcrReportingTasksResponsePage } from '../models/pcr-reporting-tasks-response-page';
import { PcrTaskStatus } from '../models/pcr-task-status';
import { PcrTaskType } from '../models/pcr-task-type';


/**
 * Positive Credit Register (PCR) API
 */
@Injectable({
  providedIn: 'root',
})
export class PcrService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listInvoicePcrReportingHistory
   */
  static readonly ListInvoicePcrReportingHistoryPath = '/invoices/{id}/pcr-status';

  /**
   * List PCR reporting history for an invoice.
   *
   * Returns a list of all PCR reporting tasks associated with the invoice.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listInvoicePcrReportingHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoicePcrReportingHistory$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'items': Array<PcrReportingTask>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, PcrService.ListInvoicePcrReportingHistoryPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'items': Array<PcrReportingTask>;
        }>;
      })
    );
  }

  /**
   * List PCR reporting history for an invoice.
   *
   * Returns a list of all PCR reporting tasks associated with the invoice.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listInvoicePcrReportingHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listInvoicePcrReportingHistory(params: {
    id: number;
    context?: HttpContext
  }
): Observable<{
'items': Array<PcrReportingTask>;
}> {

    return this.listInvoicePcrReportingHistory$Response(params).pipe(
      map((r: StrictHttpResponse<{
'items': Array<PcrReportingTask>;
}>) => r.body as {
'items': Array<PcrReportingTask>;
})
    );
  }

  /**
   * Path part for operation listPcrReportingTasks
   */
  static readonly ListPcrReportingTasksPath = '/pcr/reporting-tasks';

  /**
   * List PCR reporting tasks.
   *
   * Returns a paginated list of PCR reporting tasks, with optional filtering.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPcrReportingTasks()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPcrReportingTasks$Response(params?: {

    /**
     * Limit amount of returned results
     */
    limit?: number;

    /**
     * Cursor for the next page of results
     */
    after?: string;

    /**
     * Filter by task status
     */
    status?: Array<PcrTaskStatus>;

    /**
     * Filter by task type
     */
    task_type?: Array<PcrTaskType>;

    /**
     * Filter tasks created after this timestamp
     */
    created_after?: string;

    /**
     * Filter tasks created before this timestamp
     */
    created_before?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<PcrReportingTasksResponsePage>> {

    const rb = new RequestBuilder(this.rootUrl, PcrService.ListPcrReportingTasksPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.query('after', params.after, {});
      rb.query('status', params.status, {"style":"form","explode":false});
      rb.query('task_type', params.task_type, {"style":"form","explode":false});
      rb.query('created_after', params.created_after, {});
      rb.query('created_before', params.created_before, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PcrReportingTasksResponsePage>;
      })
    );
  }

  /**
   * List PCR reporting tasks.
   *
   * Returns a paginated list of PCR reporting tasks, with optional filtering.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listPcrReportingTasks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPcrReportingTasks(params?: {

    /**
     * Limit amount of returned results
     */
    limit?: number;

    /**
     * Cursor for the next page of results
     */
    after?: string;

    /**
     * Filter by task status
     */
    status?: Array<PcrTaskStatus>;

    /**
     * Filter by task type
     */
    task_type?: Array<PcrTaskType>;

    /**
     * Filter tasks created after this timestamp
     */
    created_after?: string;

    /**
     * Filter tasks created before this timestamp
     */
    created_before?: string;
    context?: HttpContext
  }
): Observable<PcrReportingTasksResponsePage> {

    return this.listPcrReportingTasks$Response(params).pipe(
      map((r: StrictHttpResponse<PcrReportingTasksResponsePage>) => r.body as PcrReportingTasksResponsePage)
    );
  }

}
